<template>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 601px">
        <el-table-column
            prop="email"
            label="E-mail"
            width="300">
        </el-table-column>
        <el-table-column
            prop="role"
            label="Perfil"
            width="150">
        </el-table-column>
        <el-table-column
            prop="btn"
            label="Ação"
            width="150">
        <template slot-scope="scope">
            <el-button @click="addRole(scope.row.email)" type="text" size="small" :disabled="isSameEmail(scope.row.email)">Tornar Default</el-button>
        </template>    
        </el-table-column>
    </el-table>
</template>

<script>
import firebase from 'firebase/app'

export default {
    data() {
        return {
            tableData: [],
            loading: true,
        }
    },
    methods: {
        async addRole(email) {
            var addRoleToUser = firebase.functions().httpsCallable('addRoleToUser');
            try {
                var result = await addRoleToUser({email: email, role: "default"})
                this.$alert(result.data.result);
                
            } catch (err) {
                this.$alert(err);
            }
        },
        async getUsers() {
            var getListOfUsers = firebase.functions().httpsCallable('getListOfUsers');
            try {
                var listUsers = await getListOfUsers();
                return listUsers.data.listUsers
            } catch(err) {
                this.$alert(err)
            }
        },
        isSameEmail(email) {
            if(email === firebase.auth().currentUser.email) return true;
            return false
        }
    },
    computed: {
        
    },
    async created() {
        
        this.loading = true;
        var table = await this.getUsers();
        
        var comp = {
            'admin': 1,
            'default': 2,
            'null': 3
        }
        
        table.sort((a, b) => {
            return comp[a.role] > comp[b.role] ? 1 : comp[a.role] < comp[b.role] ? -1 : 0
        })
        
        
        table.forEach(row => {
           
            var email = row.email;
            var role = row.role;
            
            this.tableData.push({
                email: email,
                role: role,
            });
        });
        
        this.loading = false
    },
}
</script>


<style scoped>
    .leq-logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 70px 0;
    }
    .login {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin: 0 auto;
    }
    .login-card {
        width: 60%;
        text-align: center;
        justify-content: center;
    }
    .login-header {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .header {
        align-items: center;
        justify-content: center;
    }
    .login-container {
        margin-bottom: 15px;
    }
    .connect {
        margin-top: 10px;
        width: 100%;
        font-size: 12.5px;
        line-height: 0.5;
        cursor: pointer;
    }
    span {
        display: block;
        margin-top: 20px;
        font-size: 11px;
    }
    h1 {
        font-family: Merriweather, serif;
        font-weight: 500;
        line-height: 1.35;
        color: #505050;
    }
    .login-footer {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .footer {
        align-items: center;
        justify-content: center;
    }
    .login-footer p {
        font-family: Merriweather, serif;
        font-weight: 30;
        line-height: 1.35;
        color: #505050;
    }
</style>